// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test'
        //suggestionPosition: 'left'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

// Click Search box Event
BCSfFilter.prototype.clickSearchBoxEvent = function(searchBoxId, ev) {
    jQ('html,body').removeClass('js-drawer-open js-drawer-open-left');

    // Show suggestion result
    if (jQ(searchBoxId).val() != '') {
        if (this.checkIsFullWidthSuggestionMobile(searchBoxId)) {
            jQ(this.selector.searchBoxMobile).val(jQ(searchBoxId).val());
            this.openSuggestionMobile(searchBoxId);
        } else {
            jQ(searchBoxId).autocomplete('search', jQ(searchBoxId).val());
        }
    }
};

BCSfFilter.prototype.afterCloseSuggestionMobile = function(searchBoxId, isCloseSearchBox) {
    if (isCloseSearchBox && jQ('.js-drawer-open').length > 0) {
        jQ('html,body').addClass('js-drawer-open js-drawer-open-left');
    }
};